import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-number-spinner',
  templateUrl: './number-spinner.component.html',
  styleUrls: ['./number-spinner.component.css']
})
export class NumberSpinnerComponent implements OnInit {

  @Input() value: number;
  @Input() minValue: number = 0;
  @Input() maxValue: number;
  @Input() increment: number = 1;
  @Input() showDeleteIcon: boolean = false;
  @Input() allowDecimal: boolean = false;
  @Output() valueChange = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void { }

  incrementValue(amount: number) {
    let newValue = this.value + (amount * this.increment);

    if (this.showDeleteIcon && newValue < this.minValue) {
      this.valueChange.emit(newValue);
      return;
    }

    if (newValue < this.minValue || newValue > this.maxValue)
      return;

    if (this.value == null)
      this.value = 1;
    else
      this.value = this.value + (amount * this.increment);

    this.valueChange.emit(this.value);
  }

  onInputChange(event: any) {
    let inputValue = parseFloat(event.target.value) || 0;

    if (this.allowDecimal) {
      // Decimal değerleri olduğu gibi kabul et
      inputValue = isNaN(inputValue) ? 0 : inputValue;
    } else {
      // Sadece tam sayıya yuvarla
      inputValue = Math.floor(inputValue);
    }

    if (inputValue < this.minValue) inputValue = this.minValue;
    if (this.maxValue != null && inputValue > this.maxValue) inputValue = this.maxValue;

    this.value = inputValue;
    this.valueChange.emit(this.value);
  }

  onlyAllowNumbers(event: KeyboardEvent) {
    const charCode = event.charCode ? event.charCode : event.keyCode;
    const key = event.key;

    // 0-9 arası sayılar
    if (charCode >= 48 && charCode <= 57) {
      return;
    }

    // Decimal için nokta veya virgül izni
    if (this.allowDecimal && (key === '.' || key === ',')) {
      return;
    }

    // Backspace, Delete, Tab, Escape, Enter, Arrow keys
    if (charCode === 8 || charCode === 9 || charCode === 27 || charCode === 13 ||
      charCode === 46 || (charCode >= 35 && charCode <= 40)) {
      return;
    }

    // Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((charCode === 65 || charCode === 67 || charCode === 86 || charCode === 88) &&
      (event.ctrlKey || event.metaKey)) {
      return;
    }

    // Diğer tüm karakterleri engelle
    event.preventDefault();
  }
}
